import { Flex, List } from "@mantine/core";

import classes from "../styles/PlansCard.module.css";

import { IconCheckFilled } from "@/components/icons";

import type { FC } from "react";

interface ContentProps {
  title: string;
  list: string[];
}

export const Content: FC<ContentProps> = ({ title, list }) => {
  if (list.length < 1) return null;

  return (
    <Flex align="start" justify="center" h="100%">
      <Flex align="center" justify="start" style={{ width: "100%" }} mt="xl">
        <List
          pl={0} // fix for unwanted padding
          classNames={{ item: classes.listItem }}
          styles={{
            itemWrapper: {
              gap: "0.25em",
            },
          }}
          icon={
            <Flex align="center" justify="center" h="auto">
              <IconCheckFilled size={30} fill="var(--mantine-color-success-7)" />
            </Flex>
          }
        >
          {list.map((el) => (
            <List.Item key={title + "_KEY_" + el} fz="sm">
              {el}
            </List.Item>
          ))}
        </List>
      </Flex>
    </Flex>
  );
};
